import { defineMessages } from 'react-intl'

const messages = {
  accept: {
    id: 'app.components.product-item-controls.accept',
    defaultMessage: 'Accept',
  },
  decline: {
    id: 'app.components.product-item-controls.decline',
    defaultMessage: 'Decline',
  },
  print: {
    id: 'app.components.product-item-controls.print',
    defaultMessage: 'Print',
  },
}

export default defineMessages(messages)
